import { render, staticRenderFns } from "./SlideNavigation.vue?vue&type=template&id=59028a3f&scoped=true&"
import script from "./SlideNavigation.vue?vue&type=script&lang=js&"
export * from "./SlideNavigation.vue?vue&type=script&lang=js&"
import style0 from "./SlideNavigation.vue?vue&type=style&index=0&id=59028a3f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59028a3f",
  null
  
)

export default component.exports